import { Button } from "@/components/ui/button";

const num = (v) => (typeof v === "number" ? v.toFixed(2) : v);
const cell = (v, unit) => (v === null || v === undefined ? "—" : `${num(v)}${unit ? ` ${unit}` : ""}`);

// Read-only table of the SbN tests snapshotted onto the assessment.
export function SbnResultsTable({ results, readOnly, onChange, onRemove }) {
  const dates = [...new Set((results.sessions || []).map((s) => s.local_date).filter(Boolean))]
    .map((d) => new Date(`${d}T00:00:00`).toLocaleDateString([], { dateStyle: "medium" }));
  return (
    <div className="space-y-2" data-testid="sbn-results-table">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="text-xs text-zinc-500">
          SbN session {dates.join(", ")} · pulled {new Date(results.pulled_at).toLocaleString()}
          {results.grip_peak_kg && (
            <span className="ml-2 text-emerald-700" data-testid="sbn-grip-summary">
              Handgrip peak: R {num(results.grip_peak_kg.right) ?? "—"} kg / L {num(results.grip_peak_kg.left) ?? "—"} kg
            </span>
          )}
        </div>
        {!readOnly && (
          <div className="flex gap-1">
            <Button size="sm" variant="outline" className="h-7 text-xs" onClick={onChange} data-testid="sbn-change-sessions-btn">
              Change sessions
            </Button>
            <Button size="sm" variant="ghost" className="h-7 text-xs text-red-700" onClick={onRemove} data-testid="sbn-remove-results-btn">
              Remove
            </Button>
          </div>
        )}
      </div>
      <div className="overflow-x-auto rounded-md border border-zinc-200">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 text-xs text-zinc-500 uppercase tracking-wider">
            <tr>
              {["Test", "Metric", "Left", "Right", "Single", "L/R diff"].map((h) => (
                <th key={h} className="text-left font-semibold px-3 py-2">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y">
            {results.tests.flatMap((t, ti) => t.results.map((r, ri) => (
              <tr key={`${ti}-${ri}`} data-testid={`sbn-result-row-${ti}-${ri}`}>
                <td className="px-3 py-1.5 font-medium text-zinc-900">{ri === 0 ? t.test : ""}</td>
                <td className="px-3 py-1.5 text-zinc-700">{r.metric}</td>
                <td className="px-3 py-1.5 font-mono-num">{cell(r.left, r.unit)}</td>
                <td className="px-3 py-1.5 font-mono-num">{cell(r.right, r.unit)}</td>
                <td className="px-3 py-1.5 font-mono-num">{cell(r.single, r.unit)}</td>
                <td className="px-3 py-1.5 font-mono-num">{r.difference === null || r.difference === undefined ? "—" : `${num(r.difference)}%`}</td>
              </tr>
            )))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
